export const createHeadline = ({ headlineTitle }) => headlineTitle || 'Fitted Kitchens';
